import { Component, OnDestroy, Inject } from '@angular/core';
import { MsgLoadingService } from './msgLoading.service';
import { Subscription } from 'rxjs';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'msgloading',
    templateUrl: './msgLoading.component.html',
    styleUrls: ['./msgLoading.component.scss']
  })
  
  export class MsgLoadingComponent implements OnDestroy {


    protected dataSubscription: Subscription;

    data:any = {};
    local;

    constructor(
        protected mls: MsgLoadingService,
        @Inject(MAT_SNACK_BAR_DATA) public dataStart: any
    ){
        this.local = dataStart.local;
        this.data = dataStart.data;
        this.dataSubscription = this.mls.data$.subscribe(result =>{
            if(this.local == result.local)
                this.data = result.data;

        });
    }

    ngOnDestroy(){
        this.dataSubscription.unsubscribe();
    }

  }
